import React, { useState, useRef, useEffect } from 'react';
import css from './ReadMoreButton.module.css';
import { FormattedMessage } from 'react-intl';
const ReadMoreButton = ({ description }) => {
//   const { description } = props;
  const text = description;

  const [showFullText, setShowFullText] = useState(false);

  const handleReadMoreClick = e => {
    e.preventDefault();
    setShowFullText(!showFullText);
  };

  return (
    <div className={css.description}>
      {showFullText ? (
        <p>
          {text}
          &nbsp;
          <span onClick={handleReadMoreClick} className={css.button}>
            {' '}
            <FormattedMessage id="ReadMoRebutton.less" />
          </span>
        </p>
      ) : (
        <p className={css.moreText}>
          {/* {text.substring(0, 300)} */}
          {text}
      
          {/* {text?.length > 300 && (
            <>
              {' '}
              ...{' '}
              <span onClick={handleReadMoreClick} className={css.button}>
                <FormattedMessage id="ReadMoRebutton.more" />
              </span>
            </>
          )} */}
        </p>
      )}
    </div>
  );
};

export default ReadMoreButton;
